<template>
  <div>
    <div
      class="container is-fluid"
      id="document-editor-wrapper"
      v-bind:class="{ 'is-loading': isLoading }"
    >
      <div class="columns" v-if="hasProp(document,'name')">
        <div class="column is-three-quarters">
          <div id="document-editor" class="box">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Document Name</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded">
                    <input
                      class="input"
                      type="text"
                      placeholder="Name"
                      v-model="document.name"
                      :disabled="isProject"
                    />
                  </div>
                </div>
              </div>
            </div>
            <ckeditor
              :editor="editor"
              :config="editorConfig"
              @ready="loadEditor"
              v-model="document.content"
            ></ckeditor>
          </div>
        </div>
        <div class="column is-one-quarter">
          <div class="browser box">
            <!-- <div class="has-text-centered">
              <h2 class="subtitle">Attachments</h2>
            </div>-->
            <documentBrowser v-if="isJournal" :files="journals" type="journal"></documentBrowser>
            <documentBrowser v-if="isProject" :files="projects" type="journal"></documentBrowser>
            <!-- <projectBrowser v-if="isProject" :projects="projects" type="journal"></projectBrowser> -->
          </div>

          <div class="buttons box">
            <button
              class="button is-link is-fullwidth is-outlined"
              v-on:click="newDocument"
              v-html="'New Document'"
            ></button>
            <button
              class="button is-link is-fullwidth is-outlined"
              v-on:click="saveDocument"
              v-html="'Save'"
            ></button>
            <!-- <button
              v-if="!isProject"
              v-bind:class="{ 'is-outlined': !document.is_in_journal}"
              class="button is-link is-fullwidth"
              v-on:click="toggleDocumentinJournal"
              v-html="document.is_in_journal ? 'Remove from Journal' : 'Add to Journal'"
            >Add to journal</button>-->
            <button
              data-target="modal"
              aria-haspopup="true"
              @click="publish_to_forums = !publish_to_forums"
              v-bind:class="{ 'is-outlined': !document.is_in_forum}"
              class="button is-link is-fullwidth"
              v-html="document.is_in_forum ? 'Remove from Forum' : 'Publish to Forum'"
            ></button>
            <div class="sub-level-container" v-show="publish_to_forums">
              <button
                v-for="(group,index) in $store.state.auth.user.groups"
                :key="index"
                v-on:click="loadForum(group.id)"
                class="button is-link is-fullwidth"
              >{{group.name}}</button>
            </div>
            <button
              class="button is-link is-fullwidth is-outlined"
              v-on:click="toggleDocumentinReview"
              v-bind:class="{ 'is-outlined': Number.isInteger(document.mentor_id)}"
              v-html="Number.isInteger(document.mentor_id) ? 'Remove from Review' : 'Send for Review'"
            ></button>

            <button class="button is-link is-fullwidth is-outlined">
              <uploader
                :headers="{'Authorization': 'Bearer ' + access_token}"
                ref="upload"
                v-model="files"
                @input-file="inputFile"
                @input-filter="inputFilter"
                class="upload-pointer"
                :post-action="api_url+'document/'+ document.id+'/save-attachment'"
              >
                <p class="full-width-label has-text-centered">Upload Attachment</p>
              </uploader>
            </button>

            <!-- <button
              class="is-link button is-outlined is-fullwidth"
              aria-haspopup="true"
              @click="showRecorder = true"
            >Voice Recording</button>-->

            <div v-for="(file) in files" class="upload-button-box" :key="file.id">
              <a v-show="!renaming && !file.success" class="is-info is-outlined">{{file.name}}</a>
              <input
                v-show="renaming && !file.success"
                class="input is-fullwidth"
                v-model="renameName"
                type="text"
                :placeholder="file.name"
              />
              <button
                v-show="renaming && !file.success"
                @click.prevent="saveRename(file, renameName)"
                class="upload-button is-fullwidth button"
              >Save</button>
              <button
                v-show="renaming && !file.success"
                @click.prevent="renameName = ''; renaming=false"
                class="upload-button is-fullwidth button"
              >Cancel</button>
              <button
                v-show="!renaming && !file.success"
                @click.prevent="renameFile(file)"
                class="upload-button is-fullwidth button"
              >Rename</button>
              <div v-if="file.error" class="has-text-danger">{{file.error}}</div>
              <div v-else-if="file.success" class="has-text-link">Uploaded Successfully!</div>
              <div v-else-if="file.active" class="has-text-link">Uploading...</div>
              <span v-else></span>
            </div>
            <button
              type="button"
              class="button is-link is-fullwidth"
              v-if="(!$refs.upload || !$refs.upload.active) && hasUploadable"
              @click.prevent="$refs.upload.active = true"
            >Start Upload</button>

            <div></div>
          </div>

          <div class="attachments box">
            <div class="has-text-centered">
              <h2 class="subtitle rightbar-subtitle">Attachments</h2>
            </div>
            <div
              v-for="(attachment) in document.attachments"
              :key="attachment.id"
              class="is-clearfix"
            >
              <a
                :href="attachment.url"
                class="is-small is-pulled-left"
                target="_blank"
              >{{ attachment.filename }}</a>
              <a
                class="button is-danger is-pulled-right"
                v-on:click="deleteAttachment(attachment.id)"
              >x</a>
            </div>
          </div>

          <div class="box">
            <div class="has-text-centered">
              <h2 class="subtitle rightbar-subtitle">Comments</h2>
            </div>
            <div class="comments">
              <div class="card" v-for="(comment, index) in document.comments" :key="index">
                <header class="card-header">
                  <p class="card-header-title">{{ comment.creator.full_name}}</p>
                  <a href="#" class="card-header-icon" aria-label="more options">
                    <span class="icon">
                      <i class="fas fa-angle-down" aria-hidden="true"></i>
                    </span>
                  </a>
                </header>
                <div class="card-content">
                  <div class="content">
                    {{ commentContent(comment.body) }}
                    <br />
                    <time datetime="2016-1-1">{{ dateFormat(comment.created_at.date)}}</time>
                  </div>
                </div>
                <!-- <footer class="card-footer">
                <a href="#" class="card-footer-item">Save</a>
                <a href="#" class="card-footer-item">Edit</a>
                <a href="#" class="card-footer-item">Delete</a>
                </footer>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <code>{{ document.content }}</code> -->
    </div>
    <div class="modal" :class="{'is-active':showRecorder}">
      <div @click="showRecorder = false" class="modal-background"></div>
      <div class="modal-content">
        <!-- <audio-recorder
          :attempts="3"
          :time="2"
          :headers="{'Authorization': 'Bearer ' + access_token}"
          :upload-url="audioUploadUrl"
        />-->
      </div>
      <button class="modal-close is-large" @click="showRecorder = false" aria-label="close"></button>
    </div>
    <div class="modal" id="modal" v-bind:class="{ 'is-active': showForumModal }">
      <div class="modal-background" @click.prevent="showForumModal = false"></div>
      <div class="modal-content" v-if="hasProp(document,'forum_post')">
        <div class="field">
          <p class="control has-icons-left has-icons-right">
            <span class="select">
              <select aria-placeholder="Topic" v-model="document.forum_post.forum_topic_id">
                <option
                  v-for="topic in forum.topics"
                  v-bind:value="topic.id"
                  :key="topic.id"
                >{{ topic.name }}</option>
              </select>
            </span>
          </p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <input
              class="input"
              placeholder="Title"
              name="message"
              v-model="document.forum_post.title"
              required
            />
          </p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <textarea
              class="textarea"
              placeholder="Your message"
              name="message"
              v-model="document.forum_post.content"
            ></textarea>
          </p>
        </div>
        <div class="field">
          <p class="control">
            <button
              :disabled="Number.isInteger(document.forum_post.id)"
              class="button is-success"
              v-on:click.once="postToForum"
              v-bind:class="{ 'is-loading': postingToForum }"
            >Post to forum</button>
          </p>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" v-on:click="showForumModal = false"></button>
    </div>
  </div>
</template>

<script>
// import CKFinder from "@ckeditor/ckeditor5-ckfinder/src/ckfinder";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import CKEditor from "@ckeditor/ckeditor5-vue";
import Uploader from "vue-upload-component";
import { mapState } from "vuex";
import { ACCESS_TOKEN, API_URL } from "../../Variables";
import documentBrowser from "@/components/files/MiniBrowser.vue";
import { ForumClient } from "../../clients/ForumClient";

export default {
  name: "EStudio",
  props: {
    documentId: {
      type: Number,
      required: false
    },
    projectId: {
      type: Number,
      required: false
    }
  },
  computed: {
    ...mapState({
      documents(state) {
        return state.documentStore.documents;
      },
      errors(state) {
        return state.documentStore.errors;
      },
      forum(state) {
        return state.forum.forum;
      },
      journals(state) {
        return state.documentStore.documents.filter(
          document => document.is_in_journal && !document.project
        );
      },
      projects(state) {
        return state.documentStore.documents.filter(
          document =>
            !document.is_in_journal && Number.isInteger(document.project_id)
        );
      }
    }),
    document() {
      if (parseInt(this.documentId)) {
        //id from router
        return this.documents.find(document => document.id === this.documentId);
      } else if (parseInt(this.projectId)) {
        //project id from router
        let projectDocument = this.documents.find(
          document => document.project_id === this.projectId
        );
        // if (!projectDocument) {
        //   this.$store.dispatch("GET_PROJECT_DOCUMENT", this.projectId);
        // }
        return projectDocument;
      } else {
        //OLD WAY: fetch newly created document
        // return this.documents[0];
        //fetch doc with NEW status
        return this.documents.find(document => document.status_id === 1);
      }
    },

    hasUploadable() {
      return this.files.length > 0 ? true : false;
    },
    isProject() {
      return (
        !isNaN(this.projectId) || Number.isInteger(this.document.project_id)
      );
    },
    isJournal() {
      return this.document.is_in_journal;
    },
    editorConfig() {
      return {
        ckfinder: {
          uploadUrl:
            this.api_url + "document/" + this.document.id + "/save-inline-image"
        }
      };
    },
    audioUploadUrl() {
      if (this.document) {
        return (
          this.api_url + "document/" + this.document.id + "/save-attachment"
        );
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      publish_to_forums: false,
      access_token: ACCESS_TOKEN,
      api_url: API_URL,
      isLoading: false,
      showForumModal: false,
      postingToForum: false,
      showRecorder: false,
      renaming: false,
      renameName: "",

      files: [],
      editor: DecoupledEditor
      // editorConfig: {
      //   ckfinder: {
      //     uploadUrl: "http://gen-lms.site/api/v3/document/2/save-inline-image"
      //   }
      // }
    };
  },
  mounted() {
    this.$store.dispatch("UNSET_DOCUMENTS");
    //Fetch all the documents for this user for the file browser
    // this.$store.dispatch("GET_USER_DOCUMENTS");

    if (parseInt(this.documentId)) {
      //id from router
      // this.$store.dispatch("GET_DOCUMENT", this.documentId);
      this.$store.dispatch("GET_USER_DOCUMENTS");
    } else if (parseInt(this.projectId)) {
      this.$store.dispatch("GET_PROJECT_DOCUMENT", this.projectId);
      //this.$store.dispatch("GET_USER_DOCUMENTS");
    } else {
      //create a new blank document defined by type param
      this.$store.dispatch("CREATE_DOCUMENT", this.$route.query.type);
    }
  },
  methods: {
    loadForum(group_id) {
      ForumClient.getForums(group_id)
        .then(result => {
          if (result.data.forums.length == 0) {
            alert("This group has no forum");
          }
          this.$store.dispatch("GET_FORUM", result.data.forums[0].id);
          this.showForumModal = true;
        })
        .catch(err => {});
    },
    saveRename(file, renameName) {
      let lastDotPosition = file.name.lastIndexOf(".");
      if (lastDotPosition == -1) {
        file.name = renameName;
      } else {
        // let name = file.name.substring(0, lastDotPosition);
        // console.log(name);
        // console.log(renameName);

        // file.name.replace(name, renameName);
        // console.log(file.name);
        file.name =
          renameName + file.name.substring(lastDotPosition, file.name.length);
      }
      this.renaming = false;
    },
    renameFile(file) {
      let name;
      let lastDotPosition = file.name.lastIndexOf(".");
      if (lastDotPosition == -1) {
        name = file.name;
      } else {
        name = file.name.substring(0, lastDotPosition);
      }

      this.renameName = name;
      this.renaming = true;
    },
    commentContent(content) {
      let decodedStr;
      try {
        decodedStr = decodeURIComponent(content);
        return decodedStr;
      } catch (e) {
        return content
      }
    },
    dateFormat(date) {
      var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
      };
      var today = new Date(date);
      var newDate = new Date(
        today.getTime() + today.getTimezoneOffset() * 60 * 1000
      );

      var offset = today.getTimezoneOffset() / 60;
      var hours = today.getHours();

      newDate.setHours(hours - offset);

      return " @" + newDate.toLocaleString("en-GB", options);
    },
    loadEditor(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    toggleDocumentinJournal: function() {
      this.document.mentor_id = !this.document.is_in_journal;
      this.isLoading = true;
      this.$store.dispatch("SAVE_DOCUMENT", this.document).then(() => {
        this.isLoading = false;
      });
    },
    toggleDocumentinReview: function() {
      if (Number.isInteger(this.document.mentor_id)) {
        this.document.mentor_id = null;
      } else {
        this.document.mentor_id = this.$store.state.auth.user.mentor[0].id;
      }
      this.isLoading = true;
      this.$store.dispatch("SAVE_DOCUMENT", this.document).then(() => {
        this.isLoading = false;
      });
    },
    postToForum: function() {
      if (
        this.document.forum_post.title != null &&
        this.document.forum_post.content != null &&
        this.document.forum_post.forum_topic_id != null
      ) {
        this.postingToForum = true;
        this.$store
          .dispatch("ADD_POST_TO_TOPIC", {
            document: this.document,
            user: this.$store.state.auth.user
          })
          .then(() => {
            this.postingToForum = false;
            this.showForumModal = false;
          });
      }
    },
    removeFromForum: function() {
      this.isLoading = true;
    },
    // toggleDocumentinForum: function() {
    //   this.document.is_in_forum = !this.document.is_in_forum;
    //   this.isLoading = true;
    //   this.$store.dispatch("SAVE_DOCUMENT", this.document).then(() => {
    //     this.isLoading = false;
    //   });
    // },
    newDocument() {
      this.isLoading = true;
      this.$store.dispatch("SAVE_DOCUMENT", this.document).then(() => {
        this.isLoading = false;
        if (this.$route.path == "/e-studio") {
          this.$router.go();
        } else {
          this.$router.push("/e-studio");
        }
      });
    },
    saveDocument: function() {
      this.isLoading = true;
      this.$store.dispatch("SAVE_DOCUMENT", this.document).then(() => {
        this.isLoading = false;
      });
    },
    deleteAttachment: function(attachment_id) {
      this.$store.dispatch("DELETE_ATTACHMENT", {
        document: this.document,
        attachment_id: attachment_id
      });
    },
    hasProp: function(obj, prop) {
      if (obj == null || obj == undefined) {
        return false;
      }
      return Object.prototype.hasOwnProperty.call(obj, prop);
    },
    /**
     * Has upload file changed
     * @param  Object|undefined   newFile   Read only
     * @param  Object|undefined   oldFile   Read only
     * @return undefined
     */
    inputFile: function(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        if (newFile.success !== oldFile.success) {
          if (newFile.xhr.status == 201) {
            this.$store.dispatch("ADD_ATTACHMENT", {
              document: this.document,
              attachment: newFile.response.attachment
            });
            // this.document.attachments.push(newFile.response.attachment);
            //todo needs a setter here
            this.files = [];
          }
        }
      }
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter: function(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        // if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
        //   return prevent();
        // }
      }

      // Create a blob field
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    }
  },
  components: {
    ckeditor: CKEditor.component,
    uploader: Uploader,
    documentBrowser
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";
.button.is-link {
  font-weight: bold !important;
  border-color: $pantoneBlue !important;
  color: $pantoneBlue !important;
  background-color: transparent !important;
  &.is-active {
    background-color: $pantoneBlue !important;
    color: white !important;
  }
  &:hover {
    background-color: $pantoneBlue !important;
    color: white !important;
  }
}

.upload-button-box {
  width: 100%;
  .upload-button {
    background-color: $pantoneBlue !important;

    &:focus {
      color: white !important;
    }
    &:active {
      color: $orange !important;
    }
  }
}

.ck-content {
  text-align: left;
  strong {
    font-weight: bold;
  }
  ol,
  ul {
    margin-left: 1rem;
  }
  ul {
    list-style-type: disc;
  }
}
span.file-uploads {
  width: 100%;
  display: flex;
}

.rightbar-subtitle {
  color: $orange !important;
  font-weight: bold;
}
.e-portfolio-button {
  margin-bottom: 1rem;
}
.comments {
  height: 50vh;
  max-height: 50vh;
  overflow-y: scroll;
}

.full-width-label {
  width: 100%;
}

.upload-pointer {
  label {
    cursor: pointer;
  }
}
</style>